import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteInvoice } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useDeleteInvoice = () => {
  const query = useQueryClient();
  const { cognitoId, clientId, userRole } = useAuth();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: async (id) => await deleteInvoice({ userId, invoiceId: id }),
    onSuccess: () => {
      query.invalidateQueries(["invoices"]);
    },
  });
};
